export default {
    data() {
        return {

        }
    },

    props: {
        data: {
            type: Object,
            default() {
                return {}
            }
        },
        width: {
            type: Number,
            default: 188
        },
        height: {
            type: Number,
            default: 188
        },
        marginBottom:  {
            type: Number,
            default: 20
        },
        fontSize: {
            type: Number,
            default: 16
        },
        color: {
            type: String,
            default: '#333333'
        }
    },

    created() {

    },

    methods: {
        clickItem() {
            if(this.data.id) {

                window.open(this._link + 'star/detail?name=' + this.data.name + '&id=' + this.data.id)
                // let data = {
                //     name: this.data.name,
                //     id: this.data.id
                // }
                // this.$router.push({
                //     name: 'star-detail',
                //     query: data
                // })
            }else {
                this.$emit('clickItem',this.data)
            }
        }
    }
}
